export default __webpack_public_path__ + "static/media/logo.7388f912.png";